import HeroSectionSlider from '@/containers/landingPage/HeroSectionSlider';
import React from 'react';
import Calendar from './Calendar';
import FeatureInfo from './featureSection/FeatureInfo';
import FeatureMap from './featureSection/FeatureMap';
import HomeDemoTestimonial from './HomeDemoTestimonial';
import MembersTabs from './MembersTabs';
import PartnerEvents from './PartnerEvents';
import { Box, Button, Flex, HStack, Link, Text } from '@chakra-ui/react';
import { MdCalendarToday, MdLocationOn } from 'react-icons/md';

const slides = [
  {
    id: 1,
    title: 'IVCA Renewable Energy Summit 2025 ',
    desc: '15th July 2025 | Mumbai ',
    showBtn: false,
    buttons: {
      text: 'Learn More',
      url: '',
    },
    banner: {
      lg: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-04-22at14410PM-iPDjf0WOMGXa.png',
    },
    contactInfo: (
      <Box
        w={{ xs: '100%', md: '60%' }}
        mt={{ xs: '10px', md: '0px' }}
        mb={{ xs: '-30px', md: '20px' }}
      >
        <Flex mt={{ xs: '12px', md: '18px' }} gap={{ xs: '4px', md: '12px' }}>
          <Link
            href="https://ivca.in/initiatives/ivca-renewables-summit-2025"
            cursor="pointer"
            aria-label="btn"
            target="_blank"
          >
            <Button
              borderRadius="none"
              fontSize={{ xs: '12px', md: '16px' }}
              fontWeight={700}
              bgColor="white"
            >
              Learn More
            </Button>
          </Link>
          <Link
            href="https://forms.gle/GqviXWY1yMcg33oT6"
            cursor="pointer"
            aria-label="btn"
            target="_blank"
          >
            <Button
              fontSize={{ xs: '12px', md: '16px' }}
              borderRadius="none"
              fontWeight={700}
              bgColor="white"
            >
              Register
            </Button>
          </Link>
        </Flex>
      </Box>
    ),
  },

  {
    id: 1,
    title: 'IVCA Climate & Sustainability Council Initiatives',
    desc: 'Mobilizing Capital for a Sustainable India. ',
    showBtn: true,
    buttons: {
      text: 'Learn More',
      url: 'https://www.ivca.in/climate-and-sustainability-council',
    },
    banner: {
      lg: 'https://static.levocdn.com/WGLBUT82/Rectangle4339-XZbabFT67YnR.svg',
      md: 'https://static.levocdn.com/WGLBUT82/Bannerformobile2-UpLgWyVqhyPC.svg',
    },
  },

  {
    id: 2,
    title: 'Welcome to IVCA',
    desc: 'Indian Venture and Alternate Capital Association (IVCA) is a not-for-profit, apex industry body promoting the alternate capital industry and fostering a vibrant investing ecosystem in India.',
    showBtn: true,
    buttons: { text: 'About Us', url: '/about-us' },
    banner: { lg: '/webp/homeSlideOne.webp' },
  },

  {
    id: 4,
    title: 'SEBI AI Simplification',
    desc: 'SEBI AI Simplification of Requirements',
    showBtn: true,
    buttons: { text: 'Read More', url: '/sebiupdates/accredited-investor' },
    banner: {
      lg: 'https://static.levocdn.com/WGLBUT82/7130124319659207262.png',
    },
  },
  {
    id: 5,
    title: 'Regulatory Reporting - SEBI',
    desc: 'Regulatory Reporting by AIFs - Circular Issued by SEBI',
    showBtn: true,
    buttons: {
      text: 'Read More',
      url: '/sebiupdates/sebi-quarterly-reporting-by-aifs',
    },
    banner: { lg: '/webp/citySkyline.webp' },
  },
];

const HomePage: React.FunctionComponent = () => (
  <>
    <HeroSectionSlider slides={slides} />
    <FeatureInfo />
    <FeatureMap />
    <Calendar />
    <PartnerEvents />
    <MembersTabs />
    <HomeDemoTestimonial />
  </>
);

export default HomePage;
